// Portal › Kullanıcılar (müşteri yöneticisi, K13) + danışman "Müşteri yöneticileri" kartı —
// UI kopya TEK kaynağı (M16 T20, DR10, mockup 16). Bileşenlerde satır içi durum/hata string'i
// yazılmaz. Müşteriye görünen metinlerde "AI", "üretim", "danışman notu" ifadesi YOK.

import { CLIENT_USER_STATUS_LABELS, type ClientUserStatus } from "@mahir/shared";

export const CLIENT_ADMIN_COPY = {
  kicker: "KULLANICILAR",
  title: "Kullanıcılar",
  subtitle:
    "Şirketinizden kimlerin performans göstergelerine erişeceğini ve form davetlerini yönetin. Hangi kategorilerin açık olduğunu danışmanınız belirler; siz yalnız daraltabilirsiniz.",
  firmSelector: "Firma",
  consultantBand: {
    label: "Danışmanınız:",
    tail: "— açık kategorileri ve veri seti kapsamını o belirler.",
    unknown: "Danışman bilgisi bulunamadı",
    lastAdmin: "Hesabınız (Süper Admin) kapatılamaz — en az bir Süper Admin gerekir.",
  },
  search: "Ad veya e-posta ara…",
  invite: "+ Davet Et",
  columns: {
    user: "KULLANICI",
    kpi: "KPI ERİŞİMİ (VERİ SETİ · DÜZENLEYEBİLİR / GÖRÜNTÜLER)",
    forms: "FORM DAVETİ",
    status: "DURUM",
  },
  /** ≤1100 px kart düzeni etiketleri (tablo başlıkları büyük harf/uzun) */
  cards: { kpi: "KPI erişimi", forms: "Form daveti" },
  statusLabel: (s: ClientUserStatus): string => CLIENT_USER_STATUS_LABELS[s],
  adminTag: "yönetici",
  youTag: "siz",
  access: {
    none: "—",
    edits: "düzenler:",
    views: "görüntüler:",
    allOpen: "tüm açık kategoriler",
    noneOpen: "açık kategori yok",
    auditorTag: "denetçi",
    /** Admin görünümü: kapsam dışı erişim ayrıntısı gösterilmez, yalnız işaret. */
    outOfScopeMark: "kapsamınız dışında da erişimi var",
    hiddenSets: (n: number) => `+${n.toString()} veri seti kapsamınız dışında`,
  },
  admins: {
    tab: "Yöneticiler",
    tabsAria: "Kullanıcı yönetimi",
    usersTab: "Kullanıcılar",
    roleColumn: "Rol",
    assign: "Yönetici ata",
    grantMatching: "Kapsamıyla aynı veri seti erişimini de ver",
    scopeBand: (cats: string, ents: string) => `Yönetici kapsamınız: ${cats} · ${ents}`,
    scopeAllCategories: "tüm kategoriler",
    scopeAllEntities: "tüm işletmeler",
    lastSuper: "Firmanın son Süper Admin'i — önce başka bir Süper Admin atayın",
    title: "Yöneticiler",
    subtitle:
      "Süper Admin her şeyi yönetir. Admin yalnız seçtiğiniz kategoriler ve işletmeler içinde kullanıcı davet eder ve erişim verir.",
    empty: "Henüz yönetici yok.",
    loadError: "Yöneticiler yüklenemedi",
    pending: "davet bekliyor",
    closed: "kapalı",
    edit: "Rol ve kapsam",
    remove: "Yöneticiliği kaldır",
    removeBody: (name: string) =>
      `${name} artık bu firmanın yöneticisi olmayacak; veri seti erişimi ve form davetleri korunur.`,
    matchingResult: (n: number, skipped: number) =>
      skipped > 0
        ? `Yönetici atandı; ${n.toString()} veri setine erişim verildi, ${skipped.toString()} veri setinde mevcut erişimi daha geniş olduğu için dokunulmadı.`
        : `Yönetici atandı; ${n.toString()} veri setine erişim verildi.`,
    assigned: "Yönetici atandı",
    updated: "Yönetici güncellendi",
    failed: "İşlem tamamlanamadı — tekrar deneyin.",
  },
  forms: {
    none: "—",
    status: {
      invited: "davetli",
      active: "aktif",
      submitted: "gönderildi",
      revoked: "iptal",
    } as Record<string, string>,
  },
  actions: {
    edit: "Düzenle",
    resend: "Yeniden gönder",
    resending: "Gönderiliyor…",
    resent: "Davet yeniden gönderildi",
    resendFailed: "Davet gönderilemedi — tekrar deneyin.",
  },
  footer: {
    range: (n: number) => (n === 0 ? "0 / 0" : `1–${n.toString()} / ${n.toString()}`),
    note: "Davetler e-posta ile gider; bağlantı 7 gün geçerlidir.",
  },
  empty: {
    title: "Henüz kullanıcı yok — davet edin",
    body: "Ekibinizi davet edin; veri seti erişimini ve form davetlerini buradan yönetirsiniz.",
    cta: "Davet gönder",
    noMatch: "Eşleşen kullanıcı yok",
  },
  loading: "Yükleniyor…",
  loadError: "Kullanıcılar yüklenemedi",
  retry: "Tekrar dene",
  inviteModal: {
    title: "Kullanıcı davet et",
    description:
      "Davet edilen kişi e-posta ile bir aktivasyon bağlantısı alır; veri seti erişimini daha sonra da düzenleyebilirsiniz.",
    fullName: "Ad Soyad",
    fullNamePlaceholder: "Örn: Ayşe Demir",
    email: "E-posta",
    emailPlaceholder: "ornek@sirket.com",
    sets: "KPI veri setleri (isteğe bağlı)",
    noSets: "Firmanızda henüz veri seti yok",
    cancel: "Vazgeç",
    submit: "Davet gönder",
    submitting: "Gönderiliyor…",
    // DR10 — tek genel mesaj
    error: "Davet gönderilemedi — e-postayı kontrol edip tekrar deneyin.",
    mailWarning: "Davet kaydedildi ancak e-posta gönderilemedi — Yeniden gönder ile deneyin.",
  },
  drawer: {
    kicker: "DÜZENLE",
    sets: "KPI veri setleri",
    noSets: "Firmanızda henüz veri seti yok",
    roleAria: (setName: string) => `${setName} rolü`,
    roleSelfNote: "Kendi rolünüzü denetçiye çevirirseniz bu veri setinde veri giremezsiniz.",
    narrowNote: "Danışmanınızın açtığı kapsamı aşamazsınız; yalnız daraltabilirsiniz.",
    /** Y2 — rol seçicinin yardım metni: rol ≠ kategori seviyesi. */
    roleHelp:
      "Veri sahibi veri girer, kanıt yükler ve onaylar. Denetçi veri setinin tamamını yalnız görüntüler; kanıt yükleme ve içe aktarma kapalıdır. Tek tek kategorileri sınırlamak için Veri sahibi + Görüntüle kullanın.",
    roleLocked: "Rolü yalnız tüm kategorileri ve işletmeleri kapsayan yöneticiler değiştirebilir.",
    categories: {
      allToggle: "Tüm kategoriler",
      consultantReadonly: "Danışman bu kategoriyi yalnız görüntülemeye açtı",
      auditorReadonly: "Denetçi rolü yalnız görüntüler",
      noneOpen: "Müşteriye açılmış kategori yok",
      parentOpen: "Üst kategori açık olduğundan bu kategori gizlenemez",
    },
    overrides: {
      title: (n: number) => `Gösterge istisnaları (${n.toString()})`,
      search: "Gösterge ara",
      noop: "etkisiz — kategori seviyesiyle aynı",
      becameCategory: "Bu gösterge artık kategori — istisna yalnız kendi satırına uygulanıyor",
      derivedWarn: (labels: string[]) =>
        `Bu göstergeden hesaplanan açık göstergeler var: ${labels.join(", ")}`,
      remove: "Kaldır",
      help: "Bir göstergeye kategoriden farklı erişim verin; istisna o gösterge için kategori seviyesinin yerine geçer.",
      empty: "İstisna yok",
      noCandidates: "İstisna eklenebilecek gösterge kalmadı",
      pathSep: " › ",
      /** SearchSelect seçenek etiketi: "etiket — kategori yolu" */
      optionLabel: (label: string, path: string) => (path ? `${label} — ${path}` : label),
      rowAria: (label: string) => `${label} — gösterge erişimi`,
    },
    // Kırılım (spec §6.5 DR10, §8 K3): bir alt kalem gizlenince toplam da gizlenir; görünür kalan
    // kalemlerden toplam türetilebilir — yönetici onaylar ya da diğerlerini de gizler. Set/grup adı,
    // "AI", "üretim", "danışman notu" YOK (client-admin-copy.test.ts kilidi; e2e 15b COPY eşleniği).
    /** "Toplam çalışan sayısı › Erkek" — uyarının başı (etiketler çalışma anında) */
    breakdownHideLead: (total: string, hidden: readonly string[]) =>
      `${total} › ${hidden.join(", ")}`,
    breakdownHideWarning:
      "Toplam gizlenecek; diğer kalemler görünür kalırsa toplam başka kalemlerden türetilebilir.",
    hideOthers: "Diğer kalemleri de gizle",
    hideOnlyThis: "Yalnız bu kalemi gizle",
    dependents: (labels: readonly string[]) =>
      `Bu toplamı kullanan hesaplanan göstergeler: ${labels.join(", ")}`,
    /** kategori listesinde toplam satırının ipucu */
    totalHiddenHint: "bir alt kalemi gizli olduğu için gizlenir",
    breakdownHideAria: (total: string) => `${total} — alt kalem gizleme uyarısı`,
    entities: {
      title: "İşletmeler",
      allToggle: "Tüm işletmeler",
      help: "Konsolide ve grup toplamları yalnız tüm işletmeleri görenlere gösterilir. Birden çok işletme seçildiğinde kullanıcı kendi işletmelerinin toplamını görür.",
      treeAria: "İşletme seçimi",
      inactive: "pasif",
      noneSelected: "En az bir işletme seçin",
    },
    scopeLocked: {
      full: "Tam erişim — yalnız Süper Admin daraltabilir",
      hidden: (n: number) => `+${n.toString()} kapsamınız dışında`,
      setOutOfScope:
        "Bu veri setinde kapsamınız dışında da erişim var — veri setinin tamamını yalnız Süper Admin kaldırabilir",
      managerReadOnly: "Yönetici olan kullanıcıların erişimini yalnız Süper Admin düzenler.",
    },
    summary: {
      edits: "düzenler",
      views: "görüntüler",
      overrides: "istisna",
      entities: "işletme",
    },
    setSummaryAria: (setName: string) => `${setName} — erişim özeti`,
    forms: "Form davetleri",
    noProjects: "Firmanızda henüz form projesi yok",
    inviteToProject: "Davet gönder",
    deactivate: "Hesabı kapat",
    save: "Kaydet",
    saving: "Kaydediliyor…",
    saved: "Erişim güncellendi",
    /** X1-m2 — "Tüm kategoriler" görünmeyen ayarlar korunsun diye açık listeye çevrildi. */
    materializedNote:
      "“Tüm kategoriler” seçimi açık listeye çevrildi: görmediğiniz göstergelerin ayarı korundu, sonradan eklenecek kategoriler bu kullanıcıya kapalı başlar.",
    saveFailed: "Erişim kaydedilemedi — tekrar deneyin.",
    close: "Kapat",
    closedReason: "Hesap zaten kapalı.",
  },
  deactivateDialog: {
    title: "Hesabı kapat",
    body: (name: string) =>
      `${name} bu firmadaki veri seti erişimini ve form davetlerini kaybedecek. Başka bir firmada bağı yoksa hesabı tamamen kapanır.`,
    confirm: "Hesabı kapat",
    failed: "Hesap kapatılamadı — tekrar deneyin.",
    lastAdmin: "Firmanın son Süper Admin'i kapatılamaz — önce başka bir Süper Admin atayın.",
  },
  projectInvite: {
    title: "Form daveti gönder",
    description: "Kişi seçtiğiniz projenin form yanıtlarını doldurmak için e-posta ile davet alır.",
    project: "Proje",
    choose: "Proje seçin…",
    submit: "Davet gönder",
    submitting: "Gönderiliyor…",
    // DR10 — tek genel mesaj
    error: "Davet gönderilemedi — tekrar deneyin.",
    sent: "Form daveti gönderildi",
    already: "zaten davetli",
  },
} as const;

/**
 * Erişim kaydı hataları (portal çekmecesi + danışman editörü ortak). Kodlar sunucudan:
 * 409 KPI_ACCESS_STALE (iyimser jeton), 409 KPI_ACCESS_BUSY (kilitlenme), 403
 * CLIENT_ADMIN_SCOPE_EXCEEDED (`details.dimension`), 422 doğrulama kodları. Kimlik yazdırılmaz.
 */
export const CLIENT_ACCESS_ERROR_COPY = {
  stale: "Bu kullanıcının erişimi siz düzenlerken değişti — güncel hali yüklendi",
  busy: "Başka bir değişiklik kaydediliyor, birkaç saniye sonra tekrar deneyin",
  generic: "Erişim kaydedilemedi — tekrar deneyin.",
  scopeFallback: "Bu değişiklik yönetici kapsamınızın dışında",
  scope: {
    categories: "Seçtiğiniz kategorilerden biri yönetici kapsamınızın dışında",
    entities: "Seçtiğiniz işletmelerden biri yönetici kapsamınızın dışında",
    overrides: "Gösterge istisnalarından biri yönetici kapsamınızın dışında",
    role: "Rolü yalnız tüm kapsamı yöneten bir yönetici değiştirebilir",
    sets: "Bu veri seti yönetici kapsamınızın dışında",
    combination:
      "Bu kullanıcının kapsamınız dışında erişimi var; bu değişikliği Süper Admin yapabilir",
    admin_target: "Yönetici olan kullanıcıların erişimini yalnız Süper Admin düzenler",
    projects: "Aktif form katılımı olan kullanıcıyı yalnız Süper Admin kapatır",
  } as Record<string, string>,
  codes: {
    override_on_category:
      "Kategori olan bir göstergede istisna var — önce istisnayı kaldırın, kategori seviyesini kullanın",
    entity_not_leaf: "Grup yerine işletmeleri tek tek seçin",
    entity_not_in_client: "Seçilen işletme bu firmaya ait değil",
    indicator_not_in_set: "Seçilen gösterge bu veri setine ait değil",
    user_closed: "Bu kullanıcının hesabı kapalı — önce hesabı açın.",
    set_not_in_client: "Seçilen veri seti bu müşteriye ait değil.",
  } as Record<string, string>,
} as const;

/** Danışman tarafı (ClientProfile › Müşteri yöneticileri kartı). */
export const CLIENT_ADMINS_CARD_COPY = {
  title: "Müşteri yöneticileri",
  hint: "Yönetici, portalda kendi ekibini davet eder ve veri seti erişimini daraltır. Açık kategorileri siz belirlersiniz.",
  empty: "Henüz yönetici yok.",
  invite: "Yönetici davet et",
  pending: "davet bekliyor",
  closed: "kapalı",
  remove: "Kaldır",
  removing: "Kaldırılıyor…",
  loadError: "Yöneticiler yüklenemedi",
  /** Danışman onay penceresi: son Süper Admin kalkarsa uyarı (danışman kurala tabi değildir). */
  noSuperWarn: "Firmanın Süper Admin'i kalmayacak",
  editRole: "Rol ve kapsam",
  fullScope: "tam kapsam",
  modal: {
    editTitle: "Rol ve kapsamı düzenle",
    role: "Rol",
    roleHelp: {
      super_admin:
        "Firmanın tüm kullanıcılarını, yöneticilerini ve projelerini yönetir; kapsam sınırı yoktur.",
      admin:
        "Yalnız aşağıda seçilen kategoriler ve işletmeler içinde kullanıcı davet eder, erişim verir.",
    },
    scope: "Yönetici kapsamı",
    scopeCategories: "Kategoriler",
    scopeEntities: "İşletmeler",
    allCategories: "Tüm kategoriler",
    allEntities: "Tüm işletmeler",
    scopeEmpty: "Admin için en az bir kategori ve bir işletme seçin",
    scopeLoadFailed:
      "Kategori ve işletme listesi yüklenemedi — kapsam bilinmeden Admin kaydedilemez.",
    scopeRetry: "Yeniden dene",
    scopeNoSets:
      "Firmada henüz veri seti yok — kategori kapsamı veri seti eklenince belirlenir; mevcut kategori kapsamı korunur.",
    save: "Kaydet",
    saving: "Kaydediliyor…",
    title: "Müşteri yöneticisi davet et",
    description:
      "Kişi yoksa e-posta ile aktivasyon bağlantısı alır; varsa yalnız yönetici yetkisi eklenir.",
    fullName: "Ad Soyad",
    email: "E-posta",
    cancel: "Vazgeç",
    submit: "Davet et",
    submitting: "Gönderiliyor…",
    errors: {
      email_internal_user: "Bu e-posta dahili bir kullanıcıya ait — müşteri yöneticisi olamaz.",
      already_admin: "Bu kişi zaten bu firmanın yöneticisi.",
      already_invited: "Bu kişiye davet zaten gönderildi — davet bekliyor.",
      user_closed: "Bu kullanıcının hesabı kapalı — önce hesabı açın.",
      validation: "Geçerli bir e-posta adresi girin.",
    } as Record<string, string>,
    emailInvalid: "Geçerli bir e-posta adresi girin (örn. ad@sirket.com).",
    genericError: "Yönetici eklenemedi — tekrar deneyin.",
    mailWarning: "Yönetici eklendi ancak e-posta gönderilemedi.",
  },
  removeDialog: {
    title: "Yöneticiyi kaldır",
    body: (name: string) =>
      `${name} artık bu firmanın yöneticisi olmayacak; mevcut veri seti erişimi ve form davetleri korunur.`,
    confirm: "Kaldır",
  },
} as const;

/** Danışman tarafı (ClientProfile › KPI erişimi kartı, TODO-KPI-19). */
export const CLIENT_KPI_ACCESS_CARD_COPY = {
  title: "KPI erişimi",
  hint: "Müşteri kullanıcılarının hangi veri setlerini görüp düzenleyeceğini buradan verirsiniz. Tavan Veri Yönetimi'ndeki kategori erişimidir; müşteri yöneticisi de portaldan aynı erişimi daraltabilir.",
  invite: "Kullanıcı davet et",
  empty: "Henüz müşteri kullanıcısı yok — davet edin.",
  noSets: "Bu müşteride henüz veri seti yok; önce Veri Yönetimi'nden veri seti açın.",
  loadError: "KPI erişimi yüklenemedi",
  retry: "Tekrar dene",
  edit: "Düzenle",
  adminTag: "yönetici",
  statusLabel: (s: ClientUserStatus): string => CLIENT_USER_STATUS_LABELS[s],
  access: {
    none: "veri seti erişimi yok",
    edits: "düzenler:",
    views: "görüntüler:",
    allOpen: "tüm açık kategoriler",
    noneOpen: "açık kategori yok",
    auditorTag: "denetçi",
  },
  editor: {
    kicker: "KPI ERİŞİMİ",
    inviteTitle: "Kullanıcı davet et",
    inviteDescription:
      'Kişi e-posta ile aktivasyon bağlantısı alır ("danışmanınız sizi davet etti"); veri seti erişimini şimdi ya da sonra verebilirsiniz.',
    fullName: "Ad Soyad",
    fullNamePlaceholder: "Örn: Ayşe Demir",
    email: "E-posta",
    emailPlaceholder: "ornek@sirket.com",
    emailInvalid: "Geçerli bir e-posta adresi girin (örn. ad@sirket.com).",
    sets: "KPI veri setleri",
    ceilingNote: "Tavan Veri Yönetimi'ndeki kategori erişimidir; burada yalnız daraltırsınız.",
    cancel: "Vazgeç",
    close: "Kapat",
    save: "Kaydet",
    saving: "Kaydediliyor…",
    saved: "Erişim güncellendi",
    submit: "Davet gönder",
    submitting: "Gönderiliyor…",
    invited: "Davet gönderildi",
    accessGrantedNoMail: "Kullanıcı zaten aktif — erişim verildi, e-posta gönderilmedi",
    mailWarning: "Davet kaydedildi ancak e-posta gönderilemedi.",
    closedReason: "Hesap kapalı — erişim verilemez.",
    errors: {
      email_internal_user: "Bu e-posta dahili bir kullanıcıya ait — müşteri olarak davet edilemez.",
      already_invited: "Bu kişi zaten bu firmanın kullanıcı listesinde — satırdan düzenleyin.",
      user_closed: "Bu kullanıcının hesabı kapalı — önce hesabı açın.",
      set_not_in_client: "Seçilen veri seti bu müşteriye ait değil.",
      forbidden: "Bu işlem için yetkiniz yok.",
      validation: "Geçerli bir e-posta adresi girin.",
    } as Record<string, string>,
    genericError: "İşlem tamamlanamadı — tekrar deneyin.",
  },
} as const;

// M17 T5 — Müşteri profili › "Raporlama takvimi" kartı (mali yıl başlangıç ayı). e2e spec 15'teki
// `COPY.calendar` bu metinlerin elle eşlenik kopyasıdır — birini değiştirince diğerini de güncelle.
export const CLIENT_CALENDAR_CARD_COPY = {
  title: "Raporlama takvimi",
  fiscalStart: "Mali yıl başlangıcı",
  calendarYear: "Takvim yılı (Ocak)",
  /** "Temmuz — MY2026: 1 Tem 2025 – 30 Haz 2026" */
  fiscalValue: (month: string, label: string, range: string) => `${month} — ${label}: ${range}`,
  /** Seçenek metni: Ocak takvim yılıdır */
  monthOption: (month: string, index: number) => (index === 0 ? `${month} (takvim yılı)` : month),
  hint: "Yalnız takvim yılı kullanmayan müşteriler için. Form soruları ve proje yılı değişmez; KPI yıl sütunları MY etiketi alır.",
  locked: "Bu müşteride KPI değerleri var — mali yıl başlangıcı artık değiştirilemez.",
  edit: "Düzenle",
  save: "Kaydet",
  cancel: "Vazgeç",
  saved: "Takvim güncellendi",
  saveError: "Kaydedilemedi",
  loadError: "Raporlama takvimi yüklenemedi",
  retry: "Tekrar dene",
  loading: "Yükleniyor…",
} as const;
